import { Box, Stack, Typography, useTheme } from '@mui/material';
import { QuestionLabelProps } from './types';

export const RequiredQuestionStar: React.FC<{ dataTestId: string }> = ({ dataTestId }) => {
  const theme = useTheme();
  return (
    <Typography
      data-testid={`${dataTestId}-required-star`}
      sx={{ color: theme.palette.error.main }}
    >
      *
    </Typography>
  );
};

export const QuestionLabel: React.FC<QuestionLabelProps> = ({
  dataTestId,
  isRequired,
  questionText,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Box
      component="label"
      data-testid={`${dataTestId}-label`}
      sx={{ color: theme.palette.gray.mediumDark, paddingBottom: theme.spacing(0.5), ...sx }}
    >
      <Stack direction="row">
        <Typography>{questionText}</Typography> &nbsp;
        {isRequired && <RequiredQuestionStar dataTestId={dataTestId} />}
      </Stack>
    </Box>
  );
};
